import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {BlocklyComponent} from "./blockly-head/blockly.component";
import {BasicLayoutComponent} from "../common/layouts/basicLayout.component";

const routes: Routes = [
  {
    path: 'blockly', component: BasicLayoutComponent,
    children: [
      { path: 'blockly', component: BlocklyComponent },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BlocklyRoutingModule { }
